import { NavBar } from '../../../../../../app/layout/NavBar';

export default NavBar;
